import { useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import { toast } from "sonner";

function formatDetail(detail) {
  if (!detail) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => (e?.msg ? e.msg : JSON.stringify(e))).join(" ");
  if (detail?.msg) return detail.msg;
  return String(detail);
}

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const [sent, setSent] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
      toast.success("If that email is registered, a reset link is on its way.");
    } catch (err) {
      toast.error(formatDetail(err?.response?.data?.detail) || "Something went wrong");
    } finally { setBusy(false); }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-50 p-6">
      <form onSubmit={submit} className="w-full max-w-sm bg-white rounded-2xl border border-slate-200/70 p-8" data-testid="forgot-form">
        <div className="flex items-center gap-2 mb-6">
          <img src="/al-axe-mark.svg" alt="" aria-hidden="true" className="h-9 w-auto" />
          <div className="font-semibold text-lg tracking-tight">AL-AXE</div>
        </div>
        <h2 className="text-3xl font-semibold tracking-tight">Reset your password</h2>
        <p className="text-slate-500 text-sm mt-1 mb-6">Enter your email and we'll send you a reset link.</p>

        {sent ? (
          <div data-testid="forgot-sent" className="rounded-xl border border-emerald-200 bg-emerald-50 text-emerald-800 p-4 text-sm">
            If <span className="font-medium">{email}</span> is registered, a reset link is on its way. It expires in 60 minutes.
          </div>
        ) : (
          <>
            <label className="text-xs font-semibold uppercase tracking-[0.15em] text-slate-500">Email</label>
            <input data-testid="forgot-email" value={email} onChange={(e)=>setEmail(e.target.value)} required type="email" autoComplete="email" className="mt-1 w-full rounded-xl border border-slate-200 px-4 py-3 focus:outline-none focus:ring-2 focus:ring-teal-400" />
            <button data-testid="forgot-submit" disabled={busy} className="mt-6 w-full al-gradient text-white font-medium py-3 rounded-full disabled:opacity-60 active:scale-[0.98]">
              {busy ? "Sending…" : "Send reset link"}
            </button>
          </>
        )}

        <div className="mt-6 text-sm text-slate-500 text-center">
          <Link to="/login" className="hover:underline">← Back to sign in</Link>
        </div>
      </form>
    </div>
  );
}
